import { Button, Group, Stack, Title } from '@mantine/core'
import { IconArrowLeft } from '@tabler/icons-react'
import { createFileRoute, useNavigate } from '@tanstack/react-router'

import { useAdminFund } from '@repo/common/queries/admin/fund'

import { DepositRecordingForm } from '@/components/DepositRecordingForm'
import { useDynamicTitle, withTitle } from '@/utils/withTitle.ts'

export const Route = createFileRoute('/_app/fund/$id/$token/record-deposit')({
  component: RecordDepositPage,
  head: withTitle(
    (params) => `Fund ${params.id} - ${params.token} - Record Deposit`,
  ),
})

function RecordDepositPage() {
  const { id, token } = Route.useParams()
  const navigate = useNavigate()
  const fund = useAdminFund(id!)

  useDynamicTitle(`${fund.data?.name} - ${token} - Record Deposit`)

  const handleGoBack = () => {
    void navigate({ to: `/fund/${id}` })
  }

  return (
    <Stack>
      <Group justify="space-between">
        <Group>
          <Button
            leftSection={<IconArrowLeft size={16} />}
            variant="subtle"
            onClick={handleGoBack}
          >
            Back to Fund
          </Button>
          <Title order={2}>
            Record Deposit - {token} - {fund.data?.name}
          </Title>
        </Group>
      </Group>

      <DepositRecordingForm fundId={id!} token={token!} />
    </Stack>
  )
}
